jQuery(document).ready(function ($) {
    const roomSlider = new Swiper('.js-room-gallery', {
        loop: true,

        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },

        slidesPerView: 1,
        speed: 1000,

        navigation: {
            nextEl: '.js-room-gallery__arrow--next',
            prevEl: '.js-room-gallery__arrow--prev'
        },

        pagination: {
            el: '.js-room-gallery__pagination',
            type: 'bullets'
        },

        autoplay: {
            delay: 5000
        }
    })
});